export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 4_00.8fc2baaa.jpg";